import { useCallback } from "react";

export const useSkillManagement = (selectedSkills, setSelectedSkills) => {
  const isSkillMatching = useCallback((skill) => selectedSkills.has(skill), [selectedSkills]);

  const toggleSkill = useCallback((skill) => {
    setSelectedSkills((prev) => {
      const set = new Set(prev);
      set.has(skill) ? set.delete(skill) : set.add(skill);
      return set;
    });
  }, [setSelectedSkills]);

  const formatSkills = useCallback((data) => {
    const safe = (arr) => Array.isArray(arr) ? arr.map(s => s?.name ?? s) : [];
    return {
      "Common Skills": safe(data.commonSkills),
      "Defining Skills": safe(data.definingSkills),
      "Distinguishing Skills": safe(data.distinguishingSkills),
      "Salary Boosting Skills": safe(data.salaryBoostingSkills),
    };
  }, []);

  const getSkillsCount = useCallback((match, skillsData) =>
    skillsData ? Object.values(skillsData).flat().filter(s => isSkillMatching(s) === match).length : 0,
    [isSkillMatching]
  );

  return {
    isSkillMatching,
    toggleSkill,
    formatSkills,
    getSkillsCount
  };
};
